import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchKnowledgeByIdRejected, fetchKnowledgeByIdSuccess } from "entities/knowledge/actions";
import type { KnowledgeItemDefaultAction } from "entities/knowledge/actionTypes";
import type { KnowledgeResponse } from "entities/knowledge/types";

export function* knowledgeItemSaga(action: KnowledgeItemDefaultAction) {
  try {
    const payload: KnowledgeResponse = yield apiFetch(`knowledge/${action.meta.id}`, {
      ...(action.meta.forceRefresh
        ? {
            headers: {
              "Cache-Control": "no-cache, no-store, must-revalidate",
            },
          }
        : {}),
    });
    yield put(fetchKnowledgeByIdSuccess(action.meta, payload));
  } catch {
    yield put(fetchKnowledgeByIdRejected({ ...action.meta, logoutOnAuthError: true }));
  }
}
